$(document).ready(function(){
  $(".produts-listingg").click(function () {
    $("#ProductGridContainer").addClass("list-view"),
    $(".produts-blockk").removeClass("active"),
    $(".produts-listingg").addClass("active"),
    $("ul#product-grid").removeClass("grid--4-col-desktop list-produts"),
    $("ul#product-grid").addClass("grid--1-col-tablet-down grid--1-col-desktop list-produts");
  }),
    
  $(".produts-blockk").click(function () {
    $("#ProductGridContainer").removeClass("list-view"),
    $(".produts-listingg").removeClass("active"),
    $(".produts-blockk").addClass("active"),
    $("ul#product-grid").removeClass("grid--1-col-tablet-down grid--1-col-desktop list-produts"),
    $("ul#product-grid").addClass("grid--4-col-desktop");
  });

  // product page variants hide show
  // $("select#Option-template--16169341911206__main-0").change(function () {
  // var selected_value = $("select#Option-template--16169341911206__main-0 option:selected").val();
  // console.log("You have selected the country - " + selected_value);
  
  //     if(selected_value == 'Frame only'){
  //         console.log('yes');
  //         $(this).parents('.custom-variants').find('.harware-variants').show();
  //     }
  //     else{
  //         console.log('no');
  //          $(this).parents('.custom-variants').find('.harware-variants').hide();
  //          $(this).parents('.custom-variants').find('.harware-variants').find('.custom').prop('disabled', 'disabled');
  //     }
  // });

  // password page hide show eye 

  $(".toggle-password").click(function() {
    $(this).toggleClass("fa-eye fa-eye-slash");
    var type = $(this).parents('.custom-pass').find('.pass-word').attr('type');
    console.log('type',type);
    if (type == "password") {
    //type.("type", "text");
      $(this).parents('.custom-pass').find('.pass-word').attr('type', "text")
        console.log('yes');
    } else {
      // type.("type", "password");
      $(this).parents('.custom-pass').find('.pass-word').attr('type', "password")
      console.log('no');
    } 
  });


  // new slideshow for home page
  $('.slideshow-main').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    fade: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          adaptiveHeight: false,
          fade: false
        }
      }
    ]
  });
  
});

// $(window).load(function() {
//  // executes when complete page is fully loaded, including all frames, objects and images

// var selected_value = $("select#Option-template--16169341911206__main-0 option:selected").val();
// console.log("You have selected the country - " + selected_value);

//     if(selected_value == 'Frame only'){
//         console.log('yes');
//         $('select#Option-template--16169341911206__main-0').parents('.custom-variants').find('.harware-variants').show();
//     }
//     else{
//         console.log('no');
//          $('select#Option-template--16169341911206__main-0').parents('.custom-variants').find('.harware-variants').hide();
//     }
// });